<template>
  <main class="tools-page">
    <section class="tools-panel">
      <div class="container">
        <div class="tools-tabs">
          <div class="tool-tab-list" role="tablist" aria-label="Araçlar">
            <button
              v-for="tool in primaryTools"
              :key="tool.key"
              type="button"
              class="tool-tab"
              :class="{ active: activeTool === tool.key }"
              role="tab"
              :aria-selected="activeTool === tool.key"
              :aria-controls="`tool-panel-${tool.key}`"
              @click="setActiveTool(tool.key)"
            >
              <span class="tool-icon">
                <i :class="tool.icon"></i>
              </span>
              <span class="tool-title">
                <small>{{ tool.type }}</small>
                <strong>{{ tool.title }}</strong>
              </span>
            </button>
          </div>

          <section
            class="tool-panel"
            role="tabpanel"
            :id="`tool-panel-${activeTool}`"
            tabindex="0"
          >
            <div class="tool-panel-body">
              <DuyuruScreen v-if="activeTool === 'duyuru'" />
              <ToplantiNotlari v-if="activeTool === 'toplanti'" />
              <TaziyeScreen v-if="activeTool === 'taziye'" />
              <TesekkurScreen v-if="activeTool === 'tesekkur'" />
              <SmsScreen v-if="activeTool === 'sms'" />
            </div>
          </section>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import DuyuruScreen from './DuyuruScreen.vue'
import ToplantiNotlari from './ToplantiNotlari.vue'
import TaziyeScreen from './TaziyeScreen.vue'
import TesekkurScreen from './TesekkurScreen.vue'
import SmsScreen from './SmsScreen.vue'

export default {
  name: 'ToolsScreen',
  components: {
    DuyuruScreen,
    ToplantiNotlari,
    TaziyeScreen,
    TesekkurScreen,
    SmsScreen
  },
  data() {
    return {
      activeTool: 'duyuru',
      primaryTools: [
        {
          key: 'duyuru',
          icon: 'fa fa-bullhorn',
          type: 'Duyuru',
          title: 'Duyuru'
        },
        {
          key: 'toplanti',
          icon: 'fa fa-list-check',
          type: 'Toplantı',
          title: 'Toplantı Notları'
        },
        {
          key: 'taziye',
          icon: 'fa fa-ribbon',
          type: 'Taziye',
          title: 'Taziye'
        },
        {
          key: 'tesekkur',
          icon: 'fa fa-award',
          type: 'Teşekkür',
          title: 'Teşekkür'
        },
        {
          key: 'sms',
          icon: 'fa fa-comment-sms',
          type: 'NetGSM',
          title: 'Toplu SMS'
        }
      ]
    }
  },
  methods: {
    setActiveTool(key) {
      this.activeTool = key
    }
  }
}
</script>

<style scoped>
.tools-page {
  background: #f5f7fb;
  min-height: 100vh;
}

.tools-panel {
  padding: 18px 0 42px;
}

.tools-tabs {
  display: grid;
  gap: 18px;
}

.tool-tab-list {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
}

.tool-tab {
  width: 100%;
  min-height: 62px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--dark);
  background: #fff;
  border: 1px solid rgba(15, 23, 43, .08);
  border-left: 4px solid transparent;
  border-radius: 8px;
  box-shadow: none;
  padding: 10px;
  text-align: left;
  transition: border-color .2s ease, background .2s ease;
}

.tool-tab:hover {
  border-color: rgba(254, 161, 22, .35);
}

.tool-tab.active {
  border-color: rgba(254, 161, 22, .48);
  border-left-color: var(--primary);
  background: #fffaf2;
}

.tool-icon {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: var(--primary);
  border-radius: 8px;
  font-size: 17px;
  flex: 0 0 38px;
}

.tool-title {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.tool-title small {
  color: var(--primary);
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
}

.tool-title strong {
  color: var(--dark);
  font-size: 15px;
  line-height: 1.18;
}

.tool-panel {
  background: #f5f7fb;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  box-shadow: none;
  overflow: hidden;
}

.tool-panel-body {
  background: #f5f7fb;
}

.tool-panel-body :deep(.announcement-tool),
.tool-panel-body :deep(.meeting-tool),
.tool-panel-body :deep(.condolence-tool),
.tool-panel-body :deep(.thanks-tool),
.tool-panel-body :deep(.sms-tool) {
  min-height: 0;
  background: transparent;
}

.tool-panel-body :deep(.announcement-editor),
.tool-panel-body :deep(.meeting-editor),
.tool-panel-body :deep(.condolence-editor),
.tool-panel-body :deep(.thanks-editor),
.tool-panel-body :deep(.sms-editor) {
  padding: 12px;
}

.tool-panel-body :deep(.tool-heading) {
  display: none;
}

.tool-panel-body :deep(.tool-container) {
  max-width: none;
  padding-left: 0;
  padding-right: 0;
}

.tool-panel-body :deep(.tool-layout) {
  grid-template-columns: minmax(320px, 440px) minmax(0, 1fr);
}

.tool-panel-body :deep(.sms-layout) {
  grid-template-columns: minmax(360px, 520px) minmax(0, 1fr);
}

.tool-panel-body :deep(.poster-scale) {
  width: min(100%, 620px);
}

@media (max-width: 991.98px) {
  .tool-tab-list {
    display: flex;
    gap: 10px;
    margin-left: -12px;
    margin-right: -12px;
    overflow-x: auto;
    padding: 0 12px 8px;
    scroll-snap-type: x proximity;
    -webkit-overflow-scrolling: touch;
  }

  .tool-tab {
    min-width: 150px;
    min-height: 58px;
    scroll-snap-align: start;
    padding: 10px;
  }

  .tool-title strong {
    font-size: 14px;
  }

  .tool-panel-body :deep(.tool-layout),
  .tool-panel-body :deep(.sms-layout) {
    grid-template-columns: 1fr;
  }

  .tool-panel-body :deep(.announcement-editor),
  .tool-panel-body :deep(.meeting-editor),
  .tool-panel-body :deep(.condolence-editor),
  .tool-panel-body :deep(.thanks-editor),
  .tool-panel-body :deep(.sms-editor) {
    padding: 12px;
  }
}
</style>
